import { styled } from "styled-components";

export const HeaderComponent = styled.header`
  width: 100%;
  height: 100px;
  position: fixed;
  top: 0;
  left: 0;
  border-bottom: 1px solid #dfdfdf;
  box-sizing: border-box;
  background-color: #ffffff;
  z-index: 200;
  .inner {
    height: 100%;
  }
  @media all and (max-width: 1024px) {
    height: 80px;
  }
  @media all and (max-width: 768px) {
    height: 60px;
  }
`;

export const HeaderLogo = styled.h1`
  img {
    width: 200px;
    height: 34px;
  }
  @media all and (max-width: 768px) {
    img {
      width: 23.438vw;
      height: 4.036vw;
    }
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const HeaderNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 40px;
  @media all and (max-width: 1024px) {
    display: none;
  }
  > ul {
    display: flex;
    align-items: center;
    gap: 40px;
    li {
      &.active {
        a {
          position: relative;
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 3px;
            background-color: #171717;
            bottom: -10px;
            left: 0;
          }
        }
      }
      a {
        color: #171717;
        font-weight: bold;
        font-size: 16px;
        /* font-family: "Pretendard"; */
        &:hover {
          color: #c1c1c1;
        }
      }
    }
  }
  > div {
    a {
      color: #171717;
      /* color: #c1c1c1; */
      font-weight: bold;
      font-size: 16px;
    }
  }
`;

export const HeaderHamBugerWrap = styled.div`
  display: none;
  @media all and (max-width: 1024px) {
    cursor: pointer;
    width: 30px;
    display: flex;
    flex-direction: column;
    gap: 6px;
    span {
      display: block;
      width: 30px;
      height: 2px;
      background-color: #171717;
    }
  }
  @media all and (max-width: 768px) {
    width: 5.208vw;
    gap: 0.781vw;
    span {
      width: 5.208vw;
      height: 0.391vw;
    }
  }
`;

export const HeaderMobNavWrap = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: -100%;
  z-index: 101;
  height: 100vh;
  transition: all 0.3s linear;
  &.active {
    right: 0;
  }
  @media all and (max-width: 1024px) {
    display: flex;
  }
`;

export const HeaderMobNavContentsWrap = styled.div`
  background-color: #fff;
  padding: 24px 20px;
  width: 40vw;
  @media all and (max-width: 768px) {
    width: 60vw;
    padding: 4.427vw 3.646vw;
  }
`;
export const HeaderMobNav = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  > ul {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 24px;
    li {
      &.active {
        a {
          position: relative;
          &::after {
            content: "";
            position: absolute;
            width: 100%;
            height: 3px;
            background-color: #171717;
            bottom: -10px;
            left: 0;
          }
        }
      }
      a {
        color: #171717;
        font-weight: bold;
        font-size: 16px;
        /* font-family: "Pretendard"; */
        &:hover {
          color: #c1c1c1;
        }
      }
    }
  }
  > div {
    a {
      color: #c1c1c1;
      font-weight: bold;
      font-size: 16px;
    }
  }
  @media all and (max-width: 768px) {
    gap: 3.646vw;
    > ul {
      gap: 3.646vw;
      li {
        &.active {
          a {
            &::after {
              height: 0.521vw;
              bottom: -1.823vw;
            }
          }
        }
        a {
          font-size: 3.385vw;
        }
      }
    }
    > div {
      a {
        font-size: 3.385vw;
      }
    }
  }
`;

export const HeaderMobNavDim = styled.div`
  display: block;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  transition: all 0.3s ease;
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  left: 0;
  /* opacity: 1;
  visibility: visible; */
  z-index: 100;
  &.active {
    opacity: 1;
    visibility: visible;
  }
`;

export const HeaderMobLogo = styled.div`
  margin-bottom: 40px;
  display: flex;
  justify-content: flex-end;
  i {
    display: block;
    width: 80%;
    img {
      width: 100%;
    }
  }
  @media all and (max-width: 768px) {
    margin-bottom: 6.51vw;
    i {
      width: 80%;
    }
  }
`;
